import * as p from '@clack/prompts'

export async function promptNoBaseDecision(
  filePath: string
): Promise<'overwrite' | 'skip' | 'backup'> {
  const answer = await p.select({
    message: `File already exists without snapshot base: ${filePath}`,
    options: [
      { value: 'backup', label: 'Backup and overwrite', hint: 'recommended' },
      { value: 'overwrite', label: 'Overwrite' },
      { value: 'skip', label: 'Skip' }
    ],
    initialValue: 'backup'
  })

  if (p.isCancel(answer)) {
    throw new Error('Generation cancelled.')
  }

  return answer as 'overwrite' | 'skip' | 'backup'
}
